<template>
  <form @submit.prevent="$emit('submit', partnerToSubmit)">
    <v-text-field
      label="Название"
      placeholder=""
      filled
      v-model="name"
    ></v-text-field>

    <v-text-field
      label="Сайт"
      placeholder=""
      filled
      v-model="site"
    ></v-text-field>

    <div v-if="isAdmin">
      <v-select
        v-if="managers.length"
        :items="managers"
        filled
        label="Менеджер"
        item-text="name"
        item-value="id"
        v-model="manager"
      ></v-select>
      <v-progress-circular
        v-else-if="!managers.length"
        class="ml-1 mb-5"
        indeterminate
        size="32"
      ></v-progress-circular>
    </div>
    <v-checkbox label="Активен" v-model="active" />

    <h2 class="mb-5">Настройки виджета</h2>

    <v-row>
      <v-col>
        <v-text-field
          label="Ссылка на YML-фид партнёра"
          placeholder=""
          filled
          v-model="ymlUrl"
        ></v-text-field>

        <v-text-field
          label="Цветовая схема виджета"
          placeholder=""
          filled
          v-model="widgetColor"
          hint="Доступные цветовые схемы: blue, green, yellow, orange, red"
        ></v-text-field>

        <v-text-field
          label="URL корзины, чтобы положить товар"
          placeholder=""
          filled
          v-model="widgetUrlCart"
          hint="Пример http://site.com/cart/?id=#id, шаблон #id будет поменяться на id товара в виджете"
        ></v-text-field>

        <v-textarea
          label="Шрифты клиента для подключения"
          placeholder="bold|//cdn1.ozone.ru/graphics/test/fonts/GT-Eesti-Pro-Display-Bold.woff2"
          filled
          v-model="widgetFonts"
          hint="1 строка - 1 шрифт в формате начертание|ссылка на шрифт"
        ></v-textarea>
      </v-col>
      <v-col>
        <div v-if="partner.id">
          <v-btn
            class="mr-2"
            v-if="!loadingYml"
            color="default"
            @click="uploadYml"
          >
            <v-icon class="mr-1">mdi-cloud-upload</v-icon>
            Загрузить товары
          </v-btn>
          <v-progress-circular
            v-else
            class="ml-1 mb-5"
            indeterminate
            size="32"
          ></v-progress-circular>
          <span v-if="partner.lastImport">
            Последний импорт:
            {{ new Date(partner.lastImport * 1000).toLocaleString() }}
          </span>
          <span v-else>
            Импорт не проводился
          </span>
        </div>

        <v-checkbox
          label="Обновлять товары по расписанию (cron)"
          v-model="importByCron"
        />

        <v-text-field
          label="Ключ Яндекс.Карт партнёра"
          placeholder=""
          filled
          v-model="yaMapKey"
          hint="Если не задан, используется ключ из настроек сайта"
        ></v-text-field>

        <v-text-field
          label="Ключ dadadata партнёра"
          placeholder=""
          filled
          v-model="dadataKey"
          hint="Если не задан, используется ключ из настроек сайта"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-btn color="primary" type="submit">Сохранить</v-btn>
  </form>
</template>

<script>
import axios from "axios";
import api from "../api";
import store from "../store";

export default {
  name: "partner-form",
  props: ["partner"],
  data() {
    let partner =
      this.partner.id !== undefined
        ? {
            name: this.partner.name,
            site: this.partner.site,
            manager: this.partner.manager,
            active: this.partner.active,
            ymlUrl: this.partner.ymlUrl,
            yaMapKey: this.partner.yaMapKey,
            dadataKey: this.partner.dadataKey,
            importByCron: this.partner.importByCron,
            widgetColor: this.partner.widgetColor,
            widgetUrlCart: this.partner.widgetUrlCart,
            widgetFonts: this.partner.widgetFonts
          }
        : {
            name: "",
            site: "",
            manager: 0,
            active: false,
            ymlUrl: "",
            yaMapKey: "",
            dadataKey: "",
            importByCron: false,
            widgetColor: "blue",
            widgetUrlCart: "",
            widgetFonts: ""
          };

    let data = {
      managers: [],
      loadingYml: false
    };

    return { ...partner, ...data };
  },
  computed: {
    partnerToSubmit() {
      return {
        name: this.name,
        site: this.site,
        manager: this.manager ? this.manager : this.currentManagerId,
        active: this.active,
        goodsCount: 0,
        ymlUrl: this.ymlUrl,
        yaMapKey: this.yaMapKey,
        dadataKey: this.dadataKey,
        importByCron: this.importByCron,
        widgetColor: this.widgetColor,
        widgetUrlCart: this.widgetUrlCart,
        widgetFonts: this.widgetFonts
      };
    },
    isAdmin() {
      return ["admin", "sv"].indexOf(store.currentUser.type) >= 0;
    },
    currentManagerId() {
      return store.currentUser.id;
    }
  },
  methods: {
    uploadYml() {
      this.loadingYml = true;
      axios
        .get(api.uploadyml(this.partner.id))
        .then(resp => {
          store.snackbar = true;
          store.snackbarSuccess = true;
          store.snackbarMessage =
            "Загрузка началась и будет выполнена в фоновом режиме.";
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loadingYml = false;
        });
    }
  },
  mounted() {
    if (this.isAdmin)
      axios.get(api.users).then(resp => {
        this.managers = resp.data;
      });
  }
};
</script>

<style></style>
